/* eslint-disable react/no-access-state-in-setstate */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import UTRModal from '../../Modal';
import * as popupActions from '../../../actions/popup-actions';
import PlayerSearch from '../../Form/PlayerSearch';

import styles from './inviteMembersModal.scss';
import BulkEmailInvite from '../../BulkEmailInvite';

let nextInviteRowId = 0;
const createInviteRow = (overrides = {}) => {
    nextInviteRowId += 1;
    return { _rowId: nextInviteRowId, displayName: '', ...overrides };
};

class InviteMembersModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            membersToInvite: [createInviteRow()],
            submitting: false,
        };

        this.onActionClick = this.onActionClick.bind(this);
        this.handlePlayerSelect = this.handlePlayerSelect.bind(this);
        this.formHasContent = this.formHasContent.bind(this);
        this.toggleAddManyAtOnce = this.toggleAddManyAtOnce.bind(this);
        this.submitBulkList = this.submitBulkList.bind(this);
    }

    componentDidUpdate() {
        console.log('InviteMembersModal state', this.state);
        console.log('InviteMembersModal props', this.props);
    }

    onActionClick() {
        this.setState({ submitting: true });
        this.props.onActionClick(this.state.membersToInvite);
    }

    handlePlayerSelect(player, index) {
        this.setState(prevState => {
            const membersToInvite = [...prevState.membersToInvite];
            const existingRowId = membersToInvite[index]?._rowId;
            if (typeof player === 'object') {
                membersToInvite[index] = { ...player, _rowId: existingRowId };
            } else if (typeof player === 'string') {
                membersToInvite[index] = { _rowId: existingRowId, email: player };
            }

            return { membersToInvite };
        });
    }

    // eslint-disable-next-line class-methods-use-this
    submitBulkList(emails) {
        const membersToInvite = emails.map(email => createInviteRow({ email }));
        this.props.onActionClick(membersToInvite);
    }

    formHasContent() {
        return (this.state.membersToInvite.some(member => member.email || member.memberId));
    }

    toggleAddManyAtOnce() {
        this.setState({
            addManyAtOnce: true,
        });
    }

    // loadEmailsOnly() { //currently members don't have email prop
    //     let emails = '';
    //     this.state.membersToInvite.forEach(member => {
    //         if (member.email) {
    //             emails = `${emails}${member.email},`;
    //         }
    //     });
    //     return emails;
    // }

    render() {
        const { onCloseClick, title } = this.props;
        const { membersToInvite, addManyAtOnce } = this.state;

        return (
            <UTRModal
                className={`modal-md`}
                onCloseClick={onCloseClick}
                config={{
                    noModalBodyPadding: false,
                    modalBodyPaddingClassName: !addManyAtOnce ? 'pl24 pr12' : 'pl24 pr24',
                    modalFooterPaddingClassName: 'pb24 pl24 pr24',
                }}
                onActionClick={this.formHasContent() ? this.onActionClick : null}
                actionLabel={!addManyAtOnce ? 'Invite Players' : ''}
                disableActionButton={this.state.submitting}
                scrollable={true}
                title={'Invite'}
            >
                <h5>{title}</h5>
                {!addManyAtOnce && (
                    <React.Fragment>
                        {membersToInvite.map((member, i) => (
                            <div className="row" key={`PlayerSearch-${member._rowId}`}>
                                <div className="col-11">
                                    <PlayerSearch
                                        index={i}
                                        className="form-control"
                                        emailTextInput={true}
                                        closeAfterSelect={true}
                                        handlePlayerSelect={this.handlePlayerSelect}
                                        value={member.displayName || member.email}
                                        placeholder="Search by name or invite by email"
                                        searchMembersOnly={true}
                                        allowQueryToBeSetToEmpty={true}
                                    />
                                </div>
                                <div className="col-1">
                                    <div
                                        className="d-inline-block mt32 clickable"
                                        onClick={() => {
                                            this.setState(prevState => {
                                                const members = [...prevState.membersToInvite];
                                                members.splice(i, 1);
                                                return { membersToInvite: members };
                                            });
                                        }}
                                    >
                                        <img src="/img/icons/close-icon-lg.svg" />
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className={`${styles.addAnotherContainer}`}>
                            <span
                                className={`${styles.addAnother} text-teal clickable fs14`}
                                onClick={() => {
                                    this.setState(prevState => ({
                                        membersToInvite: [...prevState.membersToInvite, createInviteRow()],
                                    }));
                                }}
                            >
                                Add another player
                            </span>
                            {' or '}
                            <span
                                className={`${styles.addAnother} text-teal clickable fs14`}
                                onClick={() => {
                                    this.toggleAddManyAtOnce();
                                }}
                            >
                                Add up to 500 at once
                            </span>
                        </div>
                    </React.Fragment>
                )}
                {addManyAtOnce && (
                    <BulkEmailInvite
                        className={`mt24`}
                        onSuccess={this.submitBulkList}
                    />
                )}
            </UTRModal>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        closePopup: (popup) => dispatch(popupActions.closePopup(popup)),
    };
}

export default withRouter(connect(null, mapDispatchToProps)(InviteMembersModal));
